export default "__VITE_ASSET__DioF3l8b__"